module.exports = __webpack_public_path__ + "static/img/recycleBg.7ef15994.png";